import { Component, Vue } from 'vue-property-decorator'
import { newbiesList } from '@/api/index'
import HeaderSearch from '@/components/componentWap/HeaderSearch.vue'
@Component({
    name: 'Novice',
    components: {
        HeaderSearch
    }
})
export default class extends Vue {
    private loading = false
    private dataList = []
    private async newbiesList() {
        this.loading = true
        const res = await newbiesList().finally(() => this.loading = false)
        this.dataList = res.data.list
    }
    // 立即查看
    private look(id: string) {
        const url = `/NoviceDetail?categoryId=${id}`
        this.$jump(url)
    }
    created() {
        this.newbiesList()
    }
}